__webpack_require__.p = "/wp-content/mu-plugins/react-pallet-calculator/src/dist/";